import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	CURSIVE_FRAME_FALLBACK_FONT,
	CURSIVE_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame16 = (props: TQrFrameProps) => {
	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const textColor = isNormalFrameMode(props) ? props.textColor : FRAME_BLACK
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: 'white'

	const getTextY = (fontSize: number) => {
		const boxTop = 64
		const boxHeight = 20
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				id="frame"
				x={0}
				y={0}
				width={64}
				height={84}
				rx={4}
				fill={frameBackgroundColor}
			/>
			<path
				d="M6 10a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4z"
				fill={qrBackgroundColor}
				id="qr-background"
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 12,
							y: 12,
							width: 40,
							height: 40,
						}),
					}}
				/>
			) : (
				<MockQr x={12} y={12} />
			)}
			<path
				id="arrow"
				d="M6.096 77.37s-3.764-5.443-1.203-11.627C6.01 63.022 7.539 61.8 7.539 61.8l-1.478.361-.24-.878s2.939-.379 3.643-.258c-.584 1.292-.859 3.324-.859 3.324l-.842-.086.447-1.809s-2.458 2.326-3.077 5.581c-1.048 5.495 1.255 9.198 1.255 9.198z"
				fill={textColor}
			/>
			<FrameText
				text={props.text}
				fontWeight="400"
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				xOffset={1}
				rotation={8.34}
				fontFamily={`${CURSIVE_FRAME_FONT}, ${CURSIVE_FRAME_FALLBACK_FONT}`}
			/>
		</svg>
	)
}
